<template>
  <div class="my-top-div">
    <el-row>
      <el-col :span="8">
        <div class="my-top-div1">
          <table style="width: 100%;">
            <tr>
              <td>
                <div style="width:100%;text-align:right;">
                  <img style="width: 320px;" :src="getInfo.logoUrl" fit="fill" :name="index.name" :label="index.name"></img>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="width:100%;text-align:right;">
                  <span class="my-top-span3">武汉洛克粉磨设备制造有限公司</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="my-top-div2">
          <table>
            <tr>
              <td>
                <el-input v-model="myinput" placeholder="请输入内容" style="width:430px;"></el-input>
                <el-button type="primary" icon="el-icon-search" style="width:100px" @click="wordSearch">搜索</el-button>
              </td>
            </tr>
            <tr>
              <td style="position: relative; top: 10px;">
                <span class="my-top-span1" @click="search(getInfo.nid1)">{{getInfo.showname1}}</span><span class="my-top-span2">|</span>
                <span class="my-top-span1" @click="search(getInfo.nid2)">{{getInfo.showname2}}</span><span class="my-top-span2">|</span>
                <span class="my-top-span1" @click="search(getInfo.nid3)">{{getInfo.showname3}}</span><span class="my-top-span2">|</span>
                <span class="my-top-span1" @click="search(getInfo.nid4)">{{getInfo.showname4}}</span>
              </td>
            </tr>
          </table>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="my-top-div3">
          <table>
            <tr>
              <td class="my-top-td2"><span>联系电话:{{getInfo.phone}}</span></td>
            </tr>
            <tr>
              <td class="my-top-td2"><span>联系人:{{getInfo.telephone}} {{getInfo.name}}</span></td>
            </tr>
          </table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  import {
    topSearch
  } from '@/api/top.js'

  export default {
    name: "Top",
    data: function() {
      return {
        index: {
          name: "logo",
        },
        myinput: "",
      }
    },
    getters: {},
    created() {},
    methods: {
      search(nid) {
        this.$store.state.myactive = "" + nid;
        this.$router.push({
          path: "/item/index?nid=" + nid
        });
      },
      wordSearch() {
        var myinput = this.$data.myinput;
        if (myinput == null || myinput == "") {
          alert("请输入搜索名称");
          return;
        }
        this.$router.push({
          path: "/item/search?keyword=" + myinput
        });
      },
    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
  }
</script>

<style>
  .my-top-div {
    width: 100%;
    height: 135px;
    margin: 0 auto;
    background-color: white;
    border-style: solid hidden;
    border-width: 1px;
    border-color: ghostwhite;
  }

  .my-top-div1 {}

  .my-top-div2 {
    position: relative;
    top: 30px;
  }

  .my-top-div3 {
    position: relative;
    top: 30px;
  }

  .my-top-span1 {
    text-decoration: none;
    color: lightgrey;
    cursor: pointer;
  }

  .my-top-span2 {
    font-weight: bold;
  }

  .my-top-span3 {
    font-weight: bold;
    color: royalblue;
    position: relative;
    right: 40px;
  }

  .my-top-td1 {}

  .my-top-td2 {
    color: black;
    text-align: left;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Top.vue